import agile from '../images/skills/agile.png';
import balsamiq from '../images/skills/balsamiq.png';
import bootstrap from '../images/skills/bootstrap.png';
import css from '../images/skills/css.png';
import figma from '../images/skills/figma.png';
import git from '../images/skills/git.png';
import github from '../images/skills/github.png';
import html from '../images/skills/html.png';
import ionic from '../images/skills/ionic.png';
import java from '../images/skills/java.png';
import javascript from '../images/skills/javascript.png';
import jdbc from '../images/skills/jdbc.png';
import jpa from '../images/skills/jpa.png';
import json from '../images/skills/json.png';
import junit from '../images/skills/junit.png';
import loopback from '../images/skills/loopback.png';
import maven from '../images/skills/maven.png';
import mvc from '../images/skills/mvc.png';
import mysqlWorkbench from '../images/skills/mysql-workbench.png';
import mysql from '../images/skills/mysql.png';
import netbeans from '../images/skills/netbeans.png';
import nodejs from '../images/skills/nodejs.png';
import postman from '../images/skills/postman.png';
import python from '../images/skills/python.png';
import react from '../images/skills/react.png';
import springBoot from '../images/skills/spring-boot.png';
import swift from '../images/skills/swift.png';
import thymeleaf from '../images/skills/thymeleaf.png';
import typescript from '../images/skills/typescript.png';
import vscode from '../images/skills/vscode.png';
import xcode from '../images/skills/xcode.png';


export const SkillsData = [
  {
    setName: "Languages",
    skills: [
      {
        image: java,
        alt: "Java logo",
        name: "Java"
      },
      {
        image: python,
        alt: "Python logo",
        name: "Python"
      },
      {
        image: javascript,
        alt: "JavaScript logo",
        name: "JavaScript"
      },
      {
        image: typescript,
        alt: "TypeScript logo",
        name: "TypeScript"
      },
      {
        image: swift,
        alt: "Swift logo",
        name: "Swift"
      }
    ]
  },
  {
    setName: "Front-end",
    skills: [
      {
        image: html,
        alt: "HTML logo",
        name: "HTML"
      },
      {
        image: css,
        alt: "CSS logo",
        name: "CSS"
      },
      {
        image: react,
        alt: "React.js logo",
        name: "React.js"
      },
      {
        image: bootstrap,
        alt: "Bootstrap logo",
        name: "Bootstrap"
      },
      {
        image: ionic,
        alt: "Ionic logo",
        name: "Ionic"
      },
      {
        image: thymeleaf,
        alt: "Thymeleaf logo",
        name: "Thymeleaf"
      }
    ]
  },
  {
    setName: "Back-end & Database",
    skills: [
      {
        image: springBoot,
        alt: "Spring Boot logo",
        name: "Spring Boot"
      },
      {
        image: nodejs,
        alt: "Node.js logo",
        name: "Node.js"
      },
      {
        image: loopback,
        alt: "Loopback 4 logo",
        name: "Loopback 4"
      },
      {
        image: mysql,
        alt: "MySQL logo",
        name: "MySQL"
      },
      {
        image: jdbc,
        alt: "JDBC logo",
        name: "JDBC"
      },
      {
        image: jpa,
        alt: "JPA/Hibernate logo",
        name: "JPA/Hibernate"
      }
    ]
  },
  {
    setName: "Tools",
    skills: [
      {
        image: git,
        alt: "Git logo",
        name: "Git"
      },
      {
        image: github,
        alt: "GitHub logo",
        name: "GitHub"
      },
      {
        image: netbeans,
        alt: "Netbeans logo",
        name: "Netbeans"
      },
      {
        image: vscode,
        alt: "VS Code logo",
        name: "Visual Studio"
      },
      {
        image: xcode,
        alt: "Xcode logo",
        name: "Xcode"
      },
      {
        image: postman,
        alt: "Postman logo",
        name: "Postman"
      },
      {
        image: json,
        alt: "JSON logo",
        name: "JSON"
      },
      {
        image: junit,
        alt: "JUnit logo",
        name: "JUnit"
      },
      {
        image: maven,
        alt: "Maven logo",
        name: "Maven"
      },
      {
        image: mvc,
        alt: "MVC design picture",
        name: "MVC Design"
      },
      {
        image: balsamiq,
        alt: "Balsamiq logo",
        name: "Balsamiq"
      },
      {
        image: figma,
        alt: "Figman logo",
        name: "Figma"
      },
      {
        image: mysqlWorkbench,
        alt: "MySQL Workbench icon",
        name: "MySQL Workbench"
      },
      {
        image: agile,
        alt: "Agile picture",
        name: "Agile"
      }
    ]
  }
]